import React, { useEffect, useState } from 'react'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { AiOutlinePlus, AiOutlineUnorderedList } from 'react-icons/ai'
import { FiChevronDown } from 'react-icons/fi'
import { ExportIcon, InvoiceIcon, LinkIcon, PersonIcon2, ProductIcon, ReverseIcon } from '../../Assets/AllSvg'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import BillOverview from '../BillOverview/BillOverview'
import BillInvoice from '../BillInvoice/BillInvoice'
import ExportModel from '../ExportModel/ExportModel'
import InvoiceFilterMenu from '../InvoiceFilterMenu/InvoiceFilterMenu'
import { useNavigate, useLocation } from 'react-router'
import BillingSubscriptiom from '../BillingSubscriptiom/BillingSubscriptiom'
import SubscriptionSidebar from '../SubscriptionSidebar/SubscriptionSidebar'
import BillingTestclock from '../BillingTestclock/BillingTestclock'
import SubsFilterMenu from '../SubsFilterMenu/SubsFilterMenu'

const menu = [
    { name: "overview" },
    { name: "invoices" },
    { name: "subscriptions" },
    { name: "quotes" },
    { name: "testclock" },
]

const Billing = () => {
    const [data, setData] = useState('overview')
    const [sendData, setSendData] = useState('')
    const [active, setActive] = useState(false)
    const [testSub, setTestSub] = useState(false)
    const navigate = useNavigate()
    const location = useLocation();

    useEffect(() => {
        if (location.state) {
            setData(location.state.data)
        } else {
            setData('overview')
        }
    }, [])

    return (
        <div>
            <DashboardHeader />
            <div className="max-w-[1690px] mx-auto sm:px-[40px] px-[20px] py-[8px] w-full text-[#414552]">
                <div className="flex justify-between gap-2 sm:flex-row flex-col sm:items-center mt-5">
                    <span className="text-[#30313d] text-[28px] font-bold">Billing</span>
                    {data === 'overview' &&
                        <div className="flex gap-2 justify-end">
                            <Menu>
                                <MenuHandler>
                                    <button className="flex gap-1 text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]">Actions<FiChevronDown className='text-lg translate-y-[1px]' />
                                    </button>
                                </MenuHandler>
                                <MenuList className='py-[4px] px-0 text-[14px] outline-remove menu-focus max-w-[270px] w-full overflow-hidden'>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><ReverseIcon className="fill-[#625afa]" />Menu Item 1</MenuItem>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><ReverseIcon className="fill-[#625afa]" />Create simulation</MenuItem>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><InvoiceIcon className="fill-[#625afa] h-[16px] w-[16px]" />Create invoice</MenuItem>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><InvoiceIcon className="fill-[#625afa] h-[16px] w-[16px]" />Create quote</MenuItem>
                                    <hr className="my-1" />
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><LinkIcon className="fill-[#625afa] h-[16px] w-[16px]" />Create quote</MenuItem>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><AiOutlineUnorderedList className="fill-[#625afa] text-[16px]" />Create Pricing Table</MenuItem>
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><PersonIcon2 className="fill-[#625afa] h-[16px] w-[16px]" />Configure customer portal</MenuItem>
                                    <hr className="my-1" />
                                    <MenuItem className='flex w-full gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] font-medium p-[6px_6px] mx-[4px]'><ProductIcon className="fill-[#625afa] h-[16px] w-[16px]" />Add product </MenuItem>
                                </MenuList>
                            </Menu>
                        </div>
                    }
                    {data === "invoices" &&
                        <div className='flex sm:gap-2 gap-1 justify-end'>
                            <InvoiceFilterMenu />
                            <button className='input_focus_shadow h-[30px] rounded-[6px] sm:text-[14px] text-[12px] font-semibold p-[0_8px] flex items-center sm:gap-2 gap-1' onClick={() => { setActive(true); setSendData('invoices') }}>
                                <ExportIcon />Export
                            </button>
                            <button className='flex sm:gap-2 gap-1 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] sm:text-[14px] text-[12px] items-center p-[4px_8px]' onClick={() => navigate('/billing/create')}>
                                <AiOutlinePlus className='text-white' />Create a test invoice <div className="bg-[#8d7ffa] px-[4px] h-[15px] text-[13px] flex justify-center items-center rounded">n</div>
                            </button>
                        </div>
                    }
                    {data === 'subscriptions' &&
                        <div className='flex sm:gap-2 gap-1 justify-end'>
                            <SubsFilterMenu />
                            <button className='input_focus_shadow h-[30px] rounded-[6px] sm:text-[14px] text-[12px] font-semibold p-[0_8px] flex items-center sm:gap-2 gap-1' onClick={() => { setActive(true); setSendData('subscription') }}>
                                <ExportIcon />Export
                            </button>
                            <button className='flex sm:gap-2 gap-1 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] sm:text-[14px] text-[12px] items-center p-[4px_8px]' onClick={() => setTestSub(true)}>
                                <AiOutlinePlus className='text-white' />Create subscription <div className="bg-[#8d7ffa] px-[4px] h-[15px] text-[13px] flex justify-center items-center rounded">n</div>
                            </button>
                        </div>
                    }
                </div>
                <div className='w-full overflow-x-auto border-b-[1px] border-[#d5dbe1]'>
                    <div className="flex sm:mt-0 mt-5 text-[14px] sm:w-full w-max overflow-x-auto sm:gap-[28px] gap-[22px] font-semibold">
                        {menu.map((val, i) => {
                            return (
                                <button className={`${data === val.name ? "border-[#625afa] text-[#625afa]" : "border-transparent text-[#687385]"} border-b-[2px] py-[8px] capitalize`} key={i} onClick={() => setData(val.name)}>{val.name}</button>
                            )
                        })}
                    </div>
                </div>
                {data === "overview" &&
                    <BillOverview />
                }
                {data === "invoices" &&
                    <BillInvoice />
                }
                {data === "subscriptions" &&
                    <BillingSubscriptiom />
                }
                {data === "testclock" &&
                    <BillingTestclock />
                }
            </div>
            <ExportModel active={active} setActive={setActive} sendData={sendData} />
            <SubscriptionSidebar testSub={testSub} setTestSub={setTestSub} />
        </div>
    )
}

export default Billing